import React from 'react';
import { __ } from 'artsteps2-common';
import { HeaderLink, Text } from '../../styles/GenericStyled';

import { getApiResource, getAuthUser } from '../../reducers';
import { compose, withState } from '../../enhancers';

const NavLinksView = ({ spaceSettings, currentUserId, activeLink, onClickedLink }) => {
  return [
    !spaceSettings || spaceSettings.showExhibitions
      ? { path: '/explore', name: __('explore') }
      : null,
  ].map(
    (link, idx) =>
      link && (
        <Text
          key={idx}
          type="body1"
          mycolor="#343a40"
          active={`${activeLink === link.name}`}
          onClick={() => {
            onClickedLink(link.name);
          }}
        >
          <HeaderLink mycolor="rgb(102 102 102)" to={link.path}>
            {link.name}
          </HeaderLink>
        </Text>
      ),
  );
};

const mapState = state => ({
  currentUserId: (getAuthUser(state) || {})._id,
  spaceSettings: getApiResource(state, `spaces/${window.location.hostname.split('.')[0]}`).settings,
});

const NavLinks = compose(withState(mapState))(NavLinksView);

export default NavLinks;
